export default __webpack_public_path__ + "static/Jesse_Rivest_Toadstool_021-af81f8ef8119d644e30a18de178579c0.jpg";